/* tslint:disable */

declare var Object: any;
export interface InspectorInterface {
  "id"?: number;
  "name": string;
  "username": string;
}

export class Inspector implements InspectorInterface {
  "id": number;
  "name": string;
  "username": string;
  constructor(data?: InspectorInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Inspector`.
   */
  public static getModelName() {
    return "Inspector";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Inspector for dynamic purposes.
  **/
  public static factory(data: InspectorInterface): Inspector{
    return new Inspector(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Inspector',
      plural: 'Inspectors',
      path: 'Inspectors',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "username": {
          name: 'username',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}
